import styled from 'styled-components';
import '@carvana/showroom-css-theme/Theme.css';

export const CardWrapper = styled.div`
  width: 100%;
`;

export const LoanCardHeader = styled.div`
  max-width: 912px;
`;

export const CardHeader = styled.div<any>`
  max-width: 912px;
  padding: 20px 24px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  align-items: ${(props) => props.align};
  gap: 24px;

  /* Tablet and above */
  @media (min-width: ${(props) => props.breakpoint}px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0;
  }
`;

export const Alert = styled.div`
  max-width: 912px;
`;

export const LoanHeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;

  // For Mobile Devices with resolution less than 768px
  @media (max-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  display: flex;
  justify-content: flex-start;
  font-weight: 700;

  // For Mobile Devices with resolution less than 768px
  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    // align-items: flex-start;
  }
`;

export const LoanHeaderText = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: var(--cvna-color-blue-6);

  // For Mobile Devices with resolution less than 768px
  @media (max-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 100%;
  }
`;

export const HeaderText = styled.div`
  color: var(--cvna-color-blue-6);
  display: flex;
  align-items: center;
  font-size: 20px;
  line-height: 24px;

  // For Mobile Devices with resolution less than 768px
  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    flex-wrap: wrap;
    align-items: flex-start;
  }
`;

export const CardBody = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
  padding: 0 24px 24px;
`;

export const AlertWrapper = styled.div`
  padding: 10px 16px;
  display: flex;
  align-items: center;
`;

export const AlertIcon = styled.div`
  display: flex;
  align-items: center;
`;

export const AlertText = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding-left: 4px;
`;

export const PaymentScheduleWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: ${(props) => props.theme.color.neutral.v200};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.primary.v600};
  padding: 2px 10px;

  // For Mobile Devices with resolution less than 768px
  @media (max-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 100%;
    margin-top: 20px;
    justify-content: center;
  }
`;

export const CardTitleLeft = styled(HeaderText)`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-top: 0;
`;

export const CardTitleRight = styled(HeaderText)`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-top: 0;
`;

export const HeaderIcon = styled.div<any>`
  margin-right: 16px;
  height: 32px;
`;
